var map = {
	"./16863874_5808241.jpg": 607,
	"./20230915135832_[fpdl.in]_vector-art-office-staff-their-jobs_975572-1876_full.jpg": 195,
	"./avatar.svg": 917,
	"./bg.svg": 659,
	"./categoryImage/burger.jpg": 73,
	"./categoryImage/french-fries.jpg": 387,
	"./categoryImage/meat.jpg": 453,
	"./categoryImage/pasta.png": 925,
	"./categoryImage/pizza.jpg": 129,
	"./categoryImage/salad.jpg": 504,
	"./cooking.png": 596,
	"./express-delivery.png": 390,
	"./food.png": 460,
	"./foodImage/OIP.png": 873,
	"./foodImage/hamburger.png": 746,
	"./foodImage/hamburger2.png": 163,
	"./foodImage/pasta.png": 958,
	"./foodImage/pizza.png": 962,
	"./foodImage/pizza2.png": 326,
	"./foodImage/pizza3.png": 765,
	"./foodImage/tako.png": 308,
	"./foodImage/tako2.png": 144,
	"./header-image.png": 413,
	"./logo-light.png": 731,
	"./logo.png": 338,
	"./reservation-image.jpg": 536,
	"./wave.png": 339
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 303;